import { formValueSelector } from 'redux-form';
import isPlainObj from 'is-plain-obj';
import deepFilter from 'deep-filter';
import flatMapDeep from 'lodash/flatMapDeep';
import { isSelected } from './selection';
const getMarkup = (baseMarkup, additionalMarkup) => {
  if (typeof baseMarkup !== 'number') {
    return additionalMarkup;
  }
  if (typeof additionalMarkup !== 'number') {
    return baseMarkup;
  }
  return baseMarkup + additionalMarkup;
};
const addPrice = (_ref, _ref2) => {
  let {
    price: basePrice,
    markup: baseMarkup
  } = _ref;
  let {
    price: additionalPrice,
    markup: additionalMarkup
  } = _ref2;
  return {
    price: basePrice + (additionalPrice !== null && additionalPrice !== void 0 ? additionalPrice : 0),
    markup: getMarkup(baseMarkup, additionalMarkup)
  };
};
const getPriceRecursive = arr => (Array.isArray(arr) ? arr : [arr]).reduce((total, price) => {
  if (Array.isArray(price)) {
    return addPrice(total, getPriceRecursive(price));
  }
  if (isPlainObj(price) && typeof price.price !== 'number') {
    return addPrice(total, getPriceRecursive(Object.values(price)));
  }
  return addPrice(total, price);
}, {
  price: 0,
  markup: null
});
const filterValues = input => deepFilter(input, value => {
  if (Array.isArray(value) || typeof value === 'string') {
    return value.length > 0;
  }
  if (typeof value === 'object' && value !== null) {
    return Object.keys(value).length > 0;
  }
  return value !== null;
});
export const getSelection = (name, form) => state => {
  const data = formValueSelector(form)(state, name) || {};
  const filteredData = Object.keys(data).filter(objectKey => objectKey !== 'value').reduce((newObj, key) => {
    const updatedObj = {
      ...newObj
    };
    updatedObj[key] = data[key];
    return updatedObj;
  }, {});
  return isSelected(name, form)(state) ? filterValues(Object.values(filteredData)) : [];
};
export const getPrice = (name, form) => state => {
  return getPriceRecursive(getSelection(name, form)(state));
};
export const getSelected = (name, form) => state => boundSegmentIndex => filterValues(formValueSelector(form)(state, `${name}.${boundSegmentIndex}`) || []);
export const processSeatSelection = function (seatSelection) {
  if (seatSelection === void 0) {
    seatSelection = {};
  }
  const flattenArray = flatMapDeep(seatSelection, bound => bound ? Object.values(bound) : []).filter(selection => selection !== null);
  return flattenArray.slice(1);
};
//# sourceMappingURL=seatMapContentContainerUtils.js.map